<app-eca-modal-host [heading]="heading"
                    (saveClicked)="saveTrainingRecord()"
                    (saveAndUploadClicked)="saveAndUploadDocument()" [showSaveAndUploadButton]="!isMultipleOperatives" [saveAndUploadButtonText]="'Save with Certificate'"
                    [yesButtonText]="'Save Without Certificate'" [yesButtonColour]="'warning'"
                    (editClicked)="editTrainingRecord()"
                    (cancelClicked)="cancelClicked()"
                    (helpClicked)="helpClicked()"
                    [isEditing]="editing"
                    [buttonsDisabled]="addingNewTrainingType"
                    [yesButtonIcon]="['far', 'save']"
                    [noButtonIcon]="['far', 'times']"
                    [editButtonIcon]="['far', 'edit']"
                    noButtonColour="transparent">
  <div class="container">
    <div class="row" *ngIf="showingHelp">
      <div class="col">
        <app-eca-help-alert [helpHtmlText]="helpAlertText" (helpCloseClicked)="hideHelpAlert()"></app-eca-help-alert>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <app-training-record-editor [editing]="editing"
                                    [isMultipleOperatives]="isMultipleOperatives"
                                    [trainingRecord]="trainingRecord"
                                    [trainingTypes]="trainingTypes"
                                    [saveAttempted]="saveAttempted"
                                    (saveNewTrainingTypeRequested)="saveNewTrainingTypeRequested($event)"
                                    (addNewTrainingTypeRequested)="addNewTrainingTypeRequested($event)">
        </app-training-record-editor>
      </div>
    </div>
  </div>
</app-eca-modal-host>
